import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
    class: "protein-sequence-viewer-container",
    ref: "rootContainer"
};
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "sequence-area" };
const _hoisted_4 = { class: "line-number" };
const _hoisted_5 = { class: "residues-on-line" };
const _hoisted_6 = ["onClick", "title"];
const _hoisted_7 = { class: "text-end mt-0 pb-2" };
const _hoisted_8 = {
    key: 1,
    class: "no-sequence-message"
};
const _hoisted_9 = {
    key: 2,
    class: "no-sequence-message"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.processedSequenceLines && _ctx.processedSequenceLines.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processedSequenceLines, (line) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: line.lineNumber,
                            class: "sequence-line"
                        }, [
                            _createElementVNode("span", _hoisted_4, _toDisplayString(line.lineNumberFormatted), 1),
                            _createElementVNode("div", _hoisted_5, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(line.residues, (residue) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                        class: _normalizeClass(["aa-let", ['residue', `residue-chain-${residue.chain.replace(/[^a-zA-Z0-9]/g, '')}`, { 'clicked-residue': residue.atomIndex === _ctx.clickedResidueAtomIndex, 'pulse-residue': residue.atomIndex === _ctx.pulsingResidueAtomIndex }]]),
                                        key: residue.atomIndex,
                                        ref_for: true,
                                        ref: (el) => _ctx.registerResidueRef(residue, el),
                                        style: _normalizeStyle({ backgroundColor: _ctx.getResidueColor(residue.oneLetterCode), color: _ctx.getResidueTextColor(residue.oneLetterCode) }),
                                        onClick: ($event) => (_ctx.residueClicked(residue)),
                                        title: `${residue.threeLetterCode} ${residue.resi}`,
                                        "data-bs-toggle": "tooltip",
                                        "data-bs-placement": "top"
                                    }, _toDisplayString(residue.oneLetterCode), 15, _hoisted_6));
                                }), 128))
                            ])
                        ]));
                    }), 128))
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("a", {
                        class: "link-primary",
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.copyFasta && _ctx.copyFasta(...args))),
                        style: { "font-size": "14px", "cursor": "pointer" }
                    }, "Copy as FASTA")
                ])
            ]))
            : (_ctx.sequence && _ctx.sequence.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Protein sequence is empty. "))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, " No protein sequence to display. "))
    ], 512));
}
